export default __webpack_public_path__ + "static/media/LifeInsurance.18ea639a.svg";